export default __webpack_public_path__ + "static/ewam-0f9b7cd13d18da86cb6fdc8f531bd14d.jpg";